<template>
    <div class="ReRECALLBASEObjTable">
		<div class="filter-tag-row">
			<div v-if="isAdmin">
				<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			</div>
			<div class="flex1">
				<span v-if="this.ApiData" class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">строк: {{masApi_total}}</span>
			</div>
			<div class="flex-end">
				<base-button v-if="bp_id" @click="toServices()" type="primary" class="my-0 btn" simple>К услугам</base-button>
				<ReConfigButton v-if="isAdmin" obj="RECALL_BASE"/>
			</div>
		</div> 
		
		<div class="row" v-show="isAdmin && bShowFilter">
			<div class="col-12"><ReFilter
				:masAllFilterParams="masAllFilterParams"
				v-model="objGetParams"
				v-on:filterapply="OnFilterApply"
				name="RECALL_BASE"
			/></div>
		</div>

		<div>
			<el-table :data="ApiData" 
				style="width: 100%;" 
			>
				<el-table-column
					label="Клиент"
					property="fio"
				></el-table-column>
				<el-table-column
					label="Дата создания услуги"
					property="InsertTime"
				>
					<template v-slot="scope">
						{{ $GVO.convertDateTimeFromMysql(scope.row.InsertTime) }}
					</template>
				</el-table-column>                        
				<el-table-column
					label="Название услуги"
					property="BP_NAME"
				></el-table-column>                                                		    
				<el-table-column
					label="Тип объекта"
					property="objectType_name"
				></el-table-column>
				
				<el-table-column
					label="Комнатность"
					property="roomsCountTotal"
				></el-table-column>

				<el-table-column
					label="Район"
					property="distr_id"
				>
					<template v-slot="scope">
						{{ GetDistrName(scope.row.distr_id) }}
					</template>
				</el-table-column>

				<el-table-column
								label="Цена"
								property="price"
				></el-table-column>

				<el-table-column
					width="220"
					label="Действие"
					align="right"                    	
				>
					<template v-slot="scope">
						<div v-if="!scope.row.service">
							<el-tooltip content="Взять в работу" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-success" @click="to_work(scope.row)">
										<i class="tim-icons icon-book-bookmark"></i>
									</button>											
								</el-button>
							</el-tooltip>	
						</div>
						<div v-else>
							<el-button class="no-border my-0">
								<button class="ml-3 btn btn-simple btn-success" @click="to_client(scope.row)">
									Перейти к клиенту
								</button>											
							</el-button>
						</div>
					</template>
				</el-table-column>


			</el-table>

		</div>
		<Pagination class="mt-3" :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masApi_total)" 
			:perPage="parseInt(10)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>
	</div>
</template>
<script>


import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import Pagination from 'src/our_components/RePagination';
import ReConfigButton from "../our_components/ReConfigButton.vue";

export default {
	name: 'RECALL_BASE-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReFilterBtn,
        ReFilter,
        Pagination,
		ReConfigButton,
	},
	data() {
		//this.$GVO.LoadCat('CAT_DIST',true);
		return {
			ApiData: [],
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: [], // this.currentFilterConfig(),
			masApi_total:0,
			bp_id: false,
		};
	},
	watch: {
		'this.$GVO.my_profile.adm':{
			handler(val){
				// console.log('my_profie.adm', val);
				if (val) {
					this.currentFilterConfig();
				}
			}
		},
		// Отслеживаем изменения в $root.GVO.isAdmin
		isAdmin(newVal) {
			// console.log('watch isAdmin',newVal);
			if (newVal) {
				this.currentFilterConfig();
			}
		},
	},
	computed:{
		isAdmin(){
			// console.log('isAdmin',this.$GVO.my_profile.adm, (this.$GVO.my_profile.adm == 1));
			// setTimeout(this.currentFilterConfig, 10);
			return (this.$GVO.my_profile.adm == 1);
		},
	},
	methods: {
		toggleConfig(){
			this.showConfig = !this.showConfig;
			// console.log(this.showConfig);
		},
		GetDistrName(distr_id){
			let distr_name = distr_id;
			if(this.$GVO.cats.cat_districts)
				for (let i = 0; i < this.$GVO.cats.cat_districts.length; i++) {
					if(this.$GVO.cats.cat_districts[i].id == distr_id){
						distr_name = this.$GVO.cats.cat_districts[i].name;
					}	
				}
			return distr_name;
		},
		to_client(row){
			this.$router.push({path:`/data/clients/id/${row.client_id}?service=${row.service.insert_id}`});
		},
		to_work(rowData){
			this.$GVO.Api.RECALL_BASE.TO_WORK({flt:{client_id:rowData.client_id, service_id: rowData.service_id}})
			.then((objApi) => {
				if(objApi.success === true){
					let id = this.ApiData.indexOf(rowData);
					if(id>-1) this.$set(this.ApiData,id,{...rowData, service:objApi.create_services_ret})
					// console.log(id, this.ApiData[id]);
					
				}else{
					this.$GVO.showAlert("Ошибка создания услуги",objApi.msg);
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		toServices(){
			this.$router.push({path:`/data/services?rb_service=1&srv_new=1&srv_inwork=1&bp_id=${this.bp_id}&range_type=-2&status_range_type=5`});
		},
		currentFilterConfig(){
			// console.log('filter',this.isAdmin);
			// console.log('Грузим фильтру для '+(this.isAdmin?'админа':'смерда'))
			if(this.isAdmin){
				this.$GVO.Api.RECALL_BASE.GET_FILTER({})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						//this.masAllFilterParams = objApi.config;
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			}
			return [];
		},
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}

			this.masApi_total = 0;
			this.$GVO.Api.RECALL_BASE.GET({flt:{...filter, c2p:10}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}else{
						this.ApiData = [];
					}
					this.masApi_total = objApi.total;
					this.bp_id = objApi.bp;
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		pClick(e){
			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			this.getApiData();
		},
		OnFilterApply(data){
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			const newFullPath = this.$route.path + '?' + strItogGetParams;
			if (this.$route.fullPath !== newFullPath) {
				try{
					this.$router.push({ path: newFullPath });
				}catch(e){}
			}
			// this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
	},		
	mounted() {
		this.getApiData();
	}
};
</script>
<style scoped lang="scss">
.ReRECALLBASEObjTable{
	.el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);}
	.filter-tag-row{
		justify-content: space-between;
	}
	.flex1{
		flex:1
	}
}
</style>
